document.addEventListener('DOMContentLoaded', function() {
  const popup = document.getElementById('popup');
  const openPopupButton = document.getElementById('open-popup-button');
  const closeBtn = document.getElementById('close-popup');
  const loadingMessage = document.getElementById('loading-message');
  const spinner = document.getElementById('spinner');
  const modelViewer = document.querySelector('model-viewer');

  let modelLoaded = false;

  // Åpne popup
  openPopupButton.addEventListener('click', function(e) {
    e.preventDefault();
    popup.style.display = 'flex';

    // Vis lastemelding og spinner før modell er lastet
    if (!modelLoaded) {
      loadingMessage.style.display = 'block';
      spinner.style.display = 'block';
    } else {
      loadingMessage.style.display = 'none';
      spinner.style.display = 'none';
      closeBtn.style.display = 'block';  // Vis lukkeknappen når modellen er lastet
    }
  });

  // Lukk popup
  closeBtn.addEventListener('click', function() {
    console.log('Lukkeknappen ble trykket'); // Debugging
    popup.style.display = 'none';
    loadingMessage.style.display = 'none';
    spinner.style.display = 'none';
  });

  // Lukk popup ved å klikke utenfor popupen
  window.addEventListener('click', function(e) {
    if (e.target === popup) {
      popup.style.display = 'none';
      loadingMessage.style.display = 'none';
      spinner.style.display = 'none';
    }
  });

  // Når modellen er ferdig lastet
  modelViewer.addEventListener('load', function() {
    loadingMessage.style.display = 'none';
    spinner.style.display = 'none';
    closeBtn.style.display = 'block';
    modelLoaded = true;
  });
});